import { Menu } from "@/src/types/menu.types";
import { tokenService } from "../services/auth/token.service";
import { AppRouterInstance } from "next/dist/shared/lib/app-router-context.shared-runtime";
import { apiResult, ServiceModule } from "../types/api.types";
import { LoggedResponse } from "../types/request-response.types";

const cache: Partial<Record<keyof typeof Services, ServiceModule>> = {};

export const passLoggedResponse = (result: apiResult,router:AppRouterInstance) => {
  if (
    typeof result !== "object" ||
    result === null ||
    !("status" in result) ||
    typeof (result as LoggedResponse).status !== "boolean"
  )
    logout(router);
};

export const logout = (router:AppRouterInstance) => {
      tokenService.clearToken();
      router.push('/');
};
    
export const BuildRouteMap = (
  menu: Menu
): Record<string, string> => {
  const routes: Record<string, string> = {};

  for (const item of Object.values(menu)) {
    if (!item) continue;

    if (item.route?.length === 2) {
      routes[item.route[0].replace('/dashboard','')] = item.route[1];
    }

    if (item.child) {
      Object.assign(routes, BuildRouteMap(item.child as Menu));
    }
  }

  return routes;
}

export const Services={
  "authService": ()=>import("@/src/services/auth/auth.service").then( m => m.authService ),
  "corpService": ()=>import("@/src/services/settings/corp.service").then( m => m.corpService ),
  "locService": ()=>import("@/src/services/settings/loc.service").then( m => m.locService ),
  "chartOfAccountsService": () => import("@/src/services/generalLedger/chartOfAccounts.service").then(m => m.chartOfAccountsService),
  "costCenterService": () => import("@/src/services/generalLedger/costCenter.service").then(m => m.costCenterService),
  "fiscalPeriodService": () => import("@/src/services/generalLedger/fiscalPeriod.service").then(m => m.fiscalPeriodService),
  "expenseAccrualService": () => import("@/src/services/generalLedger/expenseAccrual.service").then(m => m.expenseAccrualService),
  "journalVoucherService": () => import("@/src/services/generalLedger/journalVoucher.service").then(m => m.journalVoucherService),
  "budgetService": () => import("@/src/services/generalLedger/budget.service").then(m => m.budgetService), 
}

export const APIRouter = async (
  params: {
    c?: string | undefined;
    p?: string | undefined;
  },
  routeMap: Record<string, string>
) => {
  const route = routeMap[params.p ?? ""] as keyof typeof Services;
  if (!route) return;

  if (!cache[route]) {
    const service= await Services[route]() as ServiceModule;

    if (!service) return;

    cache[route] = service
  }

  return cache[route];
};
 